import { LabelledRow, Modal } from "components";
import { ButtonPrimary } from "components/Atoms/Button";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";
import RequiredNumberInput from "components/ValidatedFields/RequiredNumberInput";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import ValidatorContext from "formvalidation/FormContext";
import { useValidators } from "formvalidation/hooks";
import React from "react";

type FormType = {
  formId: string
  name: string
}

const SiteId = "66d12c56326a70e6d3319ce8";

const RequestTrialForm: FormType = {
  formId: "6717b5bb15c0511a7ccc5202",
  name: "Request trial form",
}

const SignUpForm: FormType = {
  formId: "6717b5bb15c0511a7ccc5223",
  name: "Sign up form",
}

interface CreateClientFields {
  type: FormType
  firstName: string
  lastName: string
  email: string
  userCount: number
}

export const CreateClientTool = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isSaving, setIsSaving] = React.useState(false);
  const [formState, setFormState] = React.useState<CreateClientFields>({
    type: RequestTrialForm,
    firstName: "",
    lastName: "",
    email: "",
    userCount: 0,
  });

  const submit = async () => {
    setIsSaving(true);

    const validationResult = await validators.validateAll();
    if (validationResult.hasErrors) {
      setIsSaving(false);
      return;
    }

    const dto: server.dto.WebflowFormSubmissionInstruction = {
      payload: {
        data: {
          firstName: formState.firstName,
          lastName: formState.lastName,
          email: formState.email,
          userCount: formState.userCount,
        },
        formId: formState.type.formId,
        id: `test-${Math.floor(Math.random() * 1000000)}`,
        siteId: SiteId,
        name: formState.type.name,
        submittedAt: new Date().toISOString(),
      },
      triggerType: "adminOneDashboard",
    };

    await window.CoreApi.WebflowWebhook.FormSubmission(dto);

    setIsSaving(false);
    setIsModalOpen(false);
  };

  const validators = useValidators();

  return <>
    <Modal
      isOpen={isModalOpen}
      handleClose={() => { setIsModalOpen(false); }}
      title="Create client"
      width={"small"}
    >
      <div>
        <ValidatorContext settings={validators.validatorSettings}>
          <table className="s1_table bordergrid gray">
            <tbody>
              <LabelledRow label="type">
                <RadioGroup
                  orientation="horizontal"
                  options={[{
                    label: RequestTrialForm.name,
                    value: RequestTrialForm.formId,
                  }, {
                    label: SignUpForm.name,
                    value: SignUpForm.formId,
                  }]}
                  value={formState.type.formId}
                  onChange={(v) => setFormState({ ...formState, type: v === RequestTrialForm.formId ? RequestTrialForm : SignUpForm })}
                />
              </LabelledRow>
              <LabelledRow label="First name">
                <RequiredTextInput
                  validatorKey="firstName"
                  value={formState.firstName}
                  onChange={(v) => setFormState({ ...formState, firstName: v })}
                  maxLength={50}
                />
              </LabelledRow>
              <LabelledRow label="Last name">
                <RequiredTextInput
                  validatorKey="lastName"
                  value={formState.lastName}
                  onChange={(v) => setFormState({ ...formState, lastName: v })}
                  maxLength={50}
                />
              </LabelledRow>
              <LabelledRow label="Email">
                <RequiredTextInput
                  validatorKey="email"
                  value={formState.email}
                  onChange={(v) => setFormState({ ...formState, email: v })}
                  maxLength={50}
                />
              </LabelledRow>
              <LabelledRow label="User count">
                <RequiredNumberInput
                  validatorKey="userCount"
                  value={formState.userCount}
                  onChange={(v) => setFormState({ ...formState, userCount: v })}
                  minValue={1}
                  maxValue={99}
                  decimalPoints={0}
                />
              </LabelledRow>
            </tbody>
          </table>
        </ValidatorContext>
      </div>
      <div className="flex margin-top-bigger">
        <div className="grow1"></div>
        <ButtonPrimary
          loading={isSaving}
          disabled={isSaving}
          onClick={() => submit()}
          label={RESX.Buttons.btnSave}
        />
      </div>
    </Modal>
    <a onClick={() => setIsModalOpen(true)}>Create client tool</a>
  </>
}